import { noop } from 'ramda-adjunct';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { HomeSlider } from '../../../../containers/Home/HomeSlider';
import {
  getNavigationButtonClickTarget,
  NavigationButtonNames,
  useTrackSearch,
} from '../../../../utils/hooks/bi/useTrachSearch';
import { Text, TextButton } from '../../../common';
import { HorizontalSection } from '../../../common/HorizontalSection';
import styles from './Section.scss';
import { IOuter } from './Section.types';
import { useVisibleItems } from './useVisibleItems';

export const Section: FC<IOuter> = ({
  title,
  action: actionFromProps,
  isSecure,
  publicMediaCurrentCategory,
  isItemSelected,
  selectedItems,
  onItemClick,
  beginDrag,
  onFileDoubleClick,
  openExpandedView,
  onItemRightClick,
  buyItem,
  items,
  maxRowsToShow,
  onShowAllClick = noop,
  onFolderDoubleClick,
  currentFolder,
  sectionClassName,
  subCategoryId,
  sectionIndex,
  sectionName,
}) => {
  const action = actionFromProps || {};

  const { visibleItems, showAllItems } = useVisibleItems({
    items,
    maxRowsToShow,
  });

  const history = useHistory();

  const handleShowAllClick = useCallback(() => {
    onShowAllClick(sectionIndex);

    if (!action || !action.url) {
      showAllItems();
    } else {
      history.push(action.url);
    }
  }, [onShowAllClick, sectionIndex, action.url]);

  const shouldShowSeeAllButton = items[0].hasMoreItemsInThisCategory;

  const { trackAddMediaButtonClickSideBar } = useTrackSearch();

  const handleNavLeftClick = useCallback(
    () =>
      trackAddMediaButtonClickSideBar({
        button_name: NavigationButtonNames.Left,
        target: getNavigationButtonClickTarget(sectionName, subCategoryId),
      }),
    [],
  );

  const handleNavRightClick = useCallback(
    () =>
      trackAddMediaButtonClickSideBar({
        button_name: NavigationButtonNames.Right,
        target: getNavigationButtonClickTarget(sectionName, subCategoryId),
      }),
    [],
  );

  return (
    <div data-hook="section">
      <HorizontalSection
        header={
          <div className={styles.sectionHeader}>
            <Text weight="bold" size="small" dataHook="section-title">
              {title}
            </Text>

            {shouldShowSeeAllButton && (
              <TextButton size="small" onClick={handleShowAllClick} dataHook="see-all-button">
                <FormattedMessage id="media-home.recent-files-section.see-all" />
              </TextButton>
            )}
          </div>
        }
        className={sectionClassName}
      >
        <HomeSlider
          items={visibleItems}
          buyItem={buyItem}
          onItemClick={onItemClick}
          onItemDoubleClick={onFileDoubleClick}
          isItemSelected={isItemSelected}
          selectedItems={selectedItems}
          isSecure={isSecure}
          beginDrag={beginDrag}
          publicMediaCurrentCategory={publicMediaCurrentCategory}
          openExpandedView={openExpandedView}
          onItemRightClick={onItemRightClick}
          onNavLeftClick={handleNavLeftClick}
          onNavRightClick={handleNavRightClick}
          onFolderDoubleClick={onFolderDoubleClick}
          currentFolder={currentFolder}
        />
      </HorizontalSection>
    </div>
  );
};
